const PROVIDER_LABELS = {
  xero: "Xero",
  quickbooks: "QuickBooks",
  myob: "MYOB",
};

export function getIntegrationProviderLabel(provider) {
  return PROVIDER_LABELS[provider] || provider;
}

export function getIntegrationStatusBadge(status) {
  if (status === "connected") {
    return { label: "Connected", variant: "success" };
  }

  return { label: "Not connected", variant: "neutral" };
}

export function buildIntegrationRows(integrations) {
  const integrationMap = integrations ?? {};

  return ["xero", "quickbooks", "myob"].map((provider) => {
    const row = integrationMap[provider] || { provider, status: "disconnected" };

    return {
      id: provider,
      provider,
      label: getIntegrationProviderLabel(provider),
      status: row.status || "disconnected",
      statusBadge: getIntegrationStatusBadge(row.status),
      detail:
        row.tenant_name ||
        row.realm_id ||
        (row.connected_at ? "Token on file" : "No active connection"),
      connectedAt: row.connected_at || null,
      tokenExpiresAt: row.token_expires_at || null,
    };
  });
}
